import { Box, Flex } from '@chakra-ui/react';

import { AboutUsContent } from '@/components/AboutUs';
import { FullFooter } from '@/components/Common/Marketing/FullFooter';
import { FullHeader } from '@/components/Common/Marketing/FullHeader';
import { PageHead } from '@/components/Common/Seo/PageHead';

export default function AboutUsPage() {
  return (
    <>
      <PageHead
        description="Bootstrapped since 2014, Neuron builds the contact-data tool sales teams actually want to use \u2014 accurate, fast, and built for outbound. Read our story."
        path="/about-us"
        title="About Neuron: Contact Data Built for Outbound Sales"
      />

      <Flex bgColor="#EEFCF8" flexDir="column" minHeight="100vh">
        <FullHeader />

        <Box overflowX="hidden">
          <AboutUsContent />
        </Box>

        <FullFooter />
      </Flex>
    </>
  );
}
